import React from 'react'
import styled from 'styled-components'
import ScrollAnimation from 'react-animate-on-scroll'

import Wrapper from 'components/Wrapper'
import Section from 'components/Section'
import { white } from 'styles/colors'
import * as spacing from 'styles/spacing'
import { H4, fontWeights } from 'styles/typography'
import { media } from 'styles/media'
import HomeOffer from './HomeOffer'
import GridItem from 'components/grid/GridItem'
import GridRow from 'components/grid/GridRow'

const Container = styled.div`
  position: relative;
  background-color: #14191d;

  ${media.medium`
    padding-bottom: ${spacing.large};
  `};
`

const Header = styled.header`
  margin-bottom: ${spacing.xxLarge};
  text-align: center;

  ${media.medium`
    margin-bottom: ${spacing.xxxLarge};
  `};

  ${media.large`
    margin-bottom: 56px;
  `};

  ${media.xLarge`
    margin-bottom: 64px;
  `};
`

const Heading = styled(H4)`
  display: block;
  font-weight: ${fontWeights.regular};
  text-transform: uppercase;
  color: ${white};
  letter-spacing: 0.1em;
  margin-bottom: 0;
`

const Offers = () => (
  <Container>
    <Section>
      <Wrapper>
        <Header as={ScrollAnimation} animateIn="fadeInUp" offset={0} animateOnce>
          <Heading as="span">New on Vuse.com</Heading>
        </Header>
        <GridRow>
          <GridItem xs="1-1" md="1-3">
            <ScrollAnimation animateIn="fadeInUp" offset={0} delay={200} animateOnce>
              <HomeOffer
                figure="home/offers/lemon-berry.jpg"
                link="/buy-online/vype-epod-vpro-cartridges/lemon-berry/"
                label="LEMON BERRY"
              />
            </ScrollAnimation>
          </GridItem>
          <GridItem xs="1-1" md="1-3">
            <ScrollAnimation animateIn="fadeInUp" offset={0} delay={400} animateOnce>
              <HomeOffer
                figure="home/offers/peach.jpg"
                link="/buy-online/vype-epod-vpro-cartridges/peach/"
                label="PEACH"
              />
            </ScrollAnimation>
          </GridItem>
          <GridItem xs="1-1" md="1-3">
            <ScrollAnimation animateIn="fadeInUp" offset={0} delay={600} animateOnce>
              <HomeOffer figure="home/offers/pouch.jpg" link="/buy-online/the-pouch/" label="THE POUCH" />
            </ScrollAnimation>
          </GridItem>
        </GridRow>
      </Wrapper>
    </Section>
  </Container>
)

export default Offers
